function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("circle", {
  cx: 21,
  cy: 26,
  r: 16,
  fill: "white"
}), React.createElement("circle", {
  cx: 21,
  cy: 26,
  r: 15,
  stroke: "#DAE1E6",
  strokeWidth: 2
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 19.6364C17.1818 19.6364 13.4682 22.3136 12 26.1136C13.4682 29.9136 17.1818 32.5909 21.5 32.5909C25.8182 32.5909 29.5318 29.9136 31 26.1136C29.5318 22.3136 25.8182 19.6364 21.5 19.6364ZM21.5 30.4318C19.0818 30.4318 17.1818 28.5318 17.1818 26.1136C17.1818 23.6955 19.0818 21.7954 21.5 21.7954C23.9182 21.7954 25.8182 23.6955 25.8182 26.1136C25.8182 28.5318 23.9182 30.4318 21.5 30.4318ZM21.5 23.5227C20.0318 23.5227 18.9091 24.6455 18.9091 26.1136C18.9091 27.5818 20.0318 28.7046 21.5 28.7046C22.9682 28.7046 24.0909 27.5818 24.0909 26.1136C24.0909 24.6455 22.9682 23.5227 21.5 23.5227Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: -5,
  y: 0,
  width: 52,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgCloseSideBar = function SvgCloseSideBar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseSideBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeSideBar.b893accd.svg";
export { ForwardRef as ReactComponent };